var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("LayoutForm", [
    _c(
      "div",
      { staticClass: "sector-edit" },
      [
        _c("div", { staticClass: "form__title" }, [
          _c("h1", [_vm._v("Upload Documents")]),
        ]),
        _vm._v(" "),
        _c("DocumentForm", {
          attrs: { "error-list": [], event_id: _vm.event_id, id: _vm.id },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }